import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../../main/main.styles';

export const AuditGridStyles = css`
  ${MainStyles}
  :host {
    display: flex;
    flex-direction: column;
  }

  .grid-styles {
    width: 100%;
    height: 100%;
  }

  .header-wrapper {
    display: flex;
    justify-content: space-between;
    margin: 10px 0 5px;
  }

  .input-wrapper {
    display: flex;
    gap: 10px;
  }
`;
